import type { FaireProductEntity } from "../../entity_types/product";

export const p_m24qga7rtw: FaireProductEntity = {
  token: "p_m24qga7rtw",
  type: "product",
  name: "Children's Tea - Organic Fairytale Dreams™",
  brandToken: "b_5bw8e8irqb",
  brandName: "Boulder Tea Company",
  imageUrl:
    "https://cdn.faire.com/fastly/8e372e578c029c6827286c67c728c31204931d3697328dba53d503e4e1c646cf.jpeg",
  galleryImageUrls: [],
  priceDollars: 8,
  description:
    "\nThis special herbal tea is the super-mellow brew pleasant dreams are made of nightly. Relaxing organic herbs including peppermint, chamomile, linden, and lemon balm intertwine magically to create a fragrant herbal blend that both adults and the little ones will savor nightly. Adding Fairytale Dreams to your evening un-wind ritual is something you’ll look forward to all day long – and maybe even dream about lucidly …it’s naturally sweet so no need to add anything!\n\nCaffeine Free\n\n1.6 oz.\n\nChamomile (organic), Lemon Balm Leaf (organic), Linden Leaf and Flower (organic), Peppermint Leaf (organic), Stevia Leaf (organic).\n\n\nAmount of Tea per 6 oz water – 1 teaspoon\nWater Temperature - 212º \nTime of Steeping - 4-7 minutes\n\nIced Tea: Brew as above and chill or double the amount of tea and pour over a full glass of ice.\n",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:54.951Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
